import React, { useEffect, useState } from 'react';
import "../Electrician/Electrician.css"
import { useNavigate } from "react-router-dom";
import img1 from "../../assets/images/CCTV/CCTV-701.jpg"
import img2 from "../../assets/images/CCTV/CCTV-702.jpg"
import img3 from "../../assets/images/CCTV/CCTV-703.webp"
import img4 from "../../assets/images/CCTV/CCTV-704.jpg"
import img5 from "../../assets/images/CCTV//CCTV-705.jpg"
import img6 from "../../assets/images/CCTV/CCTV-706.jpg"
import img7 from "../../assets/images/CCTV/CCTV-707.webp"
import img8 from "../../assets/images/CCTV/CCTV-708.jpg"
import img9 from "../../assets/images/CCTV/CCTV-709.png"
const Cctv = ({ cart, addToCart }) => {
  const navigate = useNavigate();
  const [openService, setOpenService] = useState(null);
  const services = [
    {
      id: 701,
      title: "Wireless CCTV installation",
      price: 249,
      subtitle: "Install wireless cameras for home security",
      extra_detail_1: "Install wireless cameras with proper setup",
      extra_detail_2: "Ensure stable connection and clear monitoring",
      image: img1
    },
    {
      id: 702,
      title: "4 Channel 1080P Full HD NVR CPPLUS",
      price: 2700,
      subtitle: "High-definition network video recorder with remote mobile viewing",
      extra_detail_1: "Supports up to 4 IP cameras with 1080P recording quality",
      extra_detail_2: "Mobile app monitoring, motion detection alerts & HDMI/VGA output",
      image: img2
    },
    {
      id: 703,
      title: "500GB Seagate Hard Disk",
      price: 2500,
      subtitle: "Reliable storage for CCTV recording systems",
      extra_detail_1: "Designed for 24/7 surveillance recording",
      extra_detail_2: "Compatible with most DVR/NVR security systems",
      image: img3
    },
    {
      id: 704,
      title: "2.4MP Dome & Bullet 3.6mm Cosmic Camera CPPLUS",
      price: 5200,
      subtitle: "High-resolution CCTV camera with night vision and audio support",
      extra_detail_1: "2.4MP Full HD camera with 3.6mm lens for clear monitoring",
      extra_detail_2: "Built-in audio, night vision, black & white mode for low light",
      image: img4
    },
    {
      id: 705,
      title: "CCTV Outdoor Wire 3+1 Black Colour",
      price: 1300,
      subtitle: "Durable outdoor cable for CCTV camera connections",
      extra_detail_1: "3+1 copper cable designed for video and power transmission",
      extra_detail_2: "Weather-resistant black coating suitable for outdoor installations",
      image: img5
    },
    {
      id: 706,
      title: "4U CCTV Rack",
      price: 800,
      subtitle: "Compact rack for organizing CCTV equipment",
      extra_detail_1: "Suitable for DVR, NVR, and power supply installation",
      extra_detail_2: "Durable metal build for safe equipment mounting",
      image: img6
    },
    {
      id: 707,
      title: "Power Spike Protector",
      price: 800,
      subtitle: "Protects CCTV equipment from voltage spikes",
      extra_detail_1: "Prevents damage caused by sudden power fluctuations",
      extra_detail_2: "Ideal for DVR, cameras, and CCTV power supplies",
      image: img7
    },
    {
      id: 708,
      title: "4 Channel CCTV Camera Power Supply",
      price: 500,
      subtitle: "Stable power supply for up to 4 CCTV cameras",
      extra_detail_1: "Provides consistent voltage for reliable camera performance",
      extra_detail_2: "Compact design suitable for CCTV racks and installations",
      image: img8
    },
    {
      id: 709,
      title: "CCTV Camera Installation Service",
      price: 800,
      subtitle: "Professional CCTV camera setup and installation",
      extra_detail_1: "Includes camera mounting, wiring, and connection setup",
      extra_detail_2: "Ensures proper positioning for maximum security coverage",
      image: img9
    }

  ];
  return (
    <div>
      <div className='container-fluid service-electrician'>
        <div id="Electronic">
          <h1>CCTV TECHNICIAN</h1>
        </div>
        <div className='elect-container'>
          <div className="services-section-elect">
            {services.map((service) => {
              const isAdded = cart.some(
                item => item.id === service.id && item.category === service.category
              );
              return (
                <div key={service.id} className="service-card-elect">

                  <div className="service-details-elect">
                    <h3>{service.title}</h3>

                    <div className="price-section-elect">
                      <span className="new-price-elect">₹{service.price}</span>
                    </div>
                    <button
                      className=" btn btn-link view-details-elect"
                      onClick={() =>
                        setOpenService(openService === service.id ? null : service.id)
                      }
                    >
                      View Details
                    </button>
                    {openService === service.id && (
                      <div className="extra-details-elect">
                        <p>✔ {service.extra_detail_1}</p>
                        <p>✔ {service.extra_detail_2}</p>
                      </div>
                    )}

                    <ul>
                      <li>{service.subtitle}</li>
                    </ul>
                  </div>

                  <div className="service-image-elect">
                    <img src={service.image} alt="" /><br />
                    <button
                      onClick={() => addToCart(service)}
                      className={`btn px-5 mt-2 ${isAdded ? "btn-success" : "btn-warning"
                        }`}
                    >
                      {isAdded ? "Added" : "Add"}
                    </button>
                  </div>

                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cctv
